import { render, staticRenderFns } from "./competency-completion-score.vue?vue&type=template&id=3c35f736&"
import script from "./competency-completion-score.ts?vue&type=script&lang=ts&"
export * from "./competency-completion-score.ts?vue&type=script&lang=ts&"
import style0 from "./competency-completion-score.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports